export enum PeriodFilters {
  THIRTY_DAYS = "thirtyDays",
  FOURTEEN_DAYS = "fourteenDays",
  SEVEN_DAYS = "sevenDays",
  CUSTOM = "custom"
}

export enum PeriodFiltersLabel {
  "thirtyDays" = "Últimos 30 dias",
  "fourteenDays" = "Últimos 14 dias",
  "sevenDays" = "Últimos 7 dias",
  "custom" = "Personalizado"
}

export const periodsLabels = [
  {
    value: PeriodFilters.THIRTY_DAYS,
    label: PeriodFiltersLabel.thirtyDays
  },
  {
    value: PeriodFilters.FOURTEEN_DAYS,
    label: PeriodFiltersLabel.fourteenDays
  },
  {
    value: PeriodFilters.SEVEN_DAYS,
    label: PeriodFiltersLabel.sevenDays
  },
  {
    value: PeriodFilters.CUSTOM,
    label: PeriodFiltersLabel.custom
  }
]

export const MS_PER_DAY = 24 * 60 * 60 * 1000
